import { createDraftSafeSelector, createSelector } from "@reduxjs/toolkit";

const selectCheckout = (state: any) => state.checkout;

export const selectStripePK = createDraftSafeSelector(
  [selectCheckout],
  (checkout) => checkout.stripePK.key,
);

export const selectCheckoutInfo = createDraftSafeSelector(
  [selectCheckout],
  (checkout) => checkout.information,
);

export const selectCheckoutShipping = createDraftSafeSelector(
  [selectCheckout],
  (checkout) => checkout.shipping,
);

export const selectCheckoutPayment = createDraftSafeSelector(
  [selectCheckout],
  (checkout) => checkout.payment,
);

export const selectShippingAddress = createDraftSafeSelector(
  [selectCheckoutInfo],
  (information) => information.shippingAddress,
);

export const selectShippingPrice = createDraftSafeSelector(
  [selectCheckoutShipping],
  (shipping) => parseFloat(shipping.price),
);

export const selectCardInfo = createDraftSafeSelector(
  [selectCheckoutPayment],
  (payment) => payment.method.info,
);

export const selectBillingAddress = createDraftSafeSelector(
  [selectCheckoutPayment],
  (payment) => payment.billingAddress,
);

export const selectPaymentIsBeingProcessed = createDraftSafeSelector(
  [selectCheckoutPayment],
  (payment) => payment.isBeingProcessed,
);

const selectCart = (state: any) => state.cart;

export const selectCartItems = createDraftSafeSelector(
  [selectCart],
  (cart) => cart.cartItems,
);

export const selectCartTotal = createDraftSafeSelector(
  [selectCartItems],
  (cartItems) =>
    parseFloat(
      cartItems && cartItems.length !== 0
        ? cartItems.reduce(
            (accumulatedQuantity: number, cartItem: any) =>
              accumulatedQuantity +
              parseFloat(cartItem?.quantity) *
                parseFloat(
                  cartItem?.priceSalesNow
                    ? cartItem?.priceSalesNow
                    : cartItem?.priceNow,
                ),
            0,
          )
        : 0,
    ),
);

// export const selectEstimatedTax = createDraftSafeSelector(
//   [selectCartTotal, selectShippingPrice],
//   (totalPrice, shippingPrice) =>
//     shippingPrice ? (totalPrice + shippingPrice) * 0.13 : totalPrice * 0.13,
// );

// export const selectEstimatedTotal = createDraftSafeSelector(
//   [selectCartTotal, selectShippingPrice, selectEstimatedTax],
//   (totalPrice, shippingPrice, estimatedTax) =>
//     totalPrice + (shippingPrice ? shippingPrice : 0) + estimatedTax,
// );
